import { getEventStatistic, handleEventList } from '@conviva/organism-components';
import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { allEventList, selectedEventsAtom } from '../../atom';
import { isEmpty } from 'lodash';

export const useEventFilter = ({ eventList }) => {
  const [eventFilterOn, setEventFilterOn] = useState<boolean>(false);
  const setAllEventsList = useSetAtom(allEventList);
  const setSelectedEvents = useSetAtom(selectedEventsAtom);

  const handleEventFilterOnChange = (v: boolean) => {
    setEventFilterOn(v);
  };

  useEffect(() => {
    const { eventCount } = getEventStatistic(handleEventList(eventList));
    const allEventList = Object.keys(eventCount);
    setAllEventsList(allEventList);
    if (!eventFilterOn && !isEmpty(eventCount)) {
      setSelectedEvents?.(allEventList);
    }
  }, [eventFilterOn, eventList, setAllEventsList, setSelectedEvents]);

  return {
    eventFilterOn,
    handleEventFilterOnChange,
  };
};
